/**
 * Barrel re-export for level dialogue pools. Explicitly permitted by
 * CLAUDE.md (one of the only allowed barrels, alongside state/selectors).
 * Keep entries alphabetically sorted so imports stay stable across stages.
 */

import type { DialoguePool } from '@/state/types';
import { L00_DIALOGUE } from './L00';
import { L01_DIALOGUE } from './L01';
import { L02_DIALOGUE } from './L02';
import { L03_DIALOGUE } from './L03';
import { L04_DIALOGUE } from './L04';
import { L05_DIALOGUE } from './L05';
import { L06_DIALOGUE } from './L06';
import { L07_DIALOGUE } from './L07';
import { L08_DIALOGUE } from './L08';
import { L09_DIALOGUE } from './L09';
import { L10_DIALOGUE } from './L10';
import { L11_DIALOGUE } from './L11';
import { L12_DIALOGUE } from './L12';
import { L13_DIALOGUE } from './L13';
import { L14_DIALOGUE } from './L14';
import { L15_DIALOGUE } from './L15';
import { L16_DIALOGUE } from './L16';
import { L17_DIALOGUE } from './L17';
import { L18_DIALOGUE } from './L18';
import { L19_DIALOGUE } from './L19';
import { L20_DIALOGUE } from './L20';
import { L21_DIALOGUE } from './L21';
import { L22_DIALOGUE } from './L22';
import { L23_DIALOGUE } from './L23';
import { L24_DIALOGUE } from './L24';
import { L25_DIALOGUE } from './L25';
import { L26_DIALOGUE } from './L26';
import { L27_DIALOGUE } from './L27';
import { L28_DIALOGUE } from './L28';
import { L29_DIALOGUE } from './L29';
import { L30_DIALOGUE } from './L30';
import { FALSE_ENDING_DIALOGUE } from './FalseEnding';
import { ENDGAME_DIALOGUE } from './Endgame';
import { LA_DIALOGUE } from './LA';
import { LB_DIALOGUE } from './LB';
import { LC_DIALOGUE } from './LC';
import { LD_DIALOGUE } from './LD';
import { LE_DIALOGUE } from './LE';
import { LF_DIALOGUE } from './LF';
import { LG_DIALOGUE } from './LG';
import { LH_DIALOGUE } from './LH';
import { LI_DIALOGUE } from './LI';
import { LJ_DIALOGUE } from './LJ';
import { LK_DIALOGUE } from './LK';

export const DIALOGUE_BY_LEVEL = {
  L00: LC_DIALOGUE,
  L01: L01_DIALOGUE,
  L02: L02_DIALOGUE,
  L03: L03_DIALOGUE,
  L04: L04_DIALOGUE,
  L05: L05_DIALOGUE,
  L06: L06_DIALOGUE,
  L07: L07_DIALOGUE,
  L08: L08_DIALOGUE,
  L09: L09_DIALOGUE,
  L10: L10_DIALOGUE,
  L11: L11_DIALOGUE,
  L12: L12_DIALOGUE,
  L13: L13_DIALOGUE,
  L14: L14_DIALOGUE,
  L15: L15_DIALOGUE,
  L16: L16_DIALOGUE,
  L17: L17_DIALOGUE,
  L18: LB_DIALOGUE,
  L19: L19_DIALOGUE,
  L20: L20_DIALOGUE,
  L21: L21_DIALOGUE,
  L22: LD_DIALOGUE,
  L23: L23_DIALOGUE,
  L24: L24_DIALOGUE,
  L25: L25_DIALOGUE,
  L26: LE_DIALOGUE,
  L27: LG_DIALOGUE,
  L28: L28_DIALOGUE,
  L29: L29_DIALOGUE,
  L30: L30_DIALOGUE,
  FALSE_ENDING: FALSE_ENDING_DIALOGUE,
  ENDGAME: ENDGAME_DIALOGUE,
  L33: LA_DIALOGUE,
  L38: LF_DIALOGUE,
  L40: LH_DIALOGUE,
  L34: LI_DIALOGUE,
  L35: LJ_DIALOGUE,
  L36: LK_DIALOGUE,
} as const satisfies Record<string, DialoguePool>;

export type DialogueLevelKey = keyof typeof DIALOGUE_BY_LEVEL;

export {
  L00_DIALOGUE,
  L01_DIALOGUE,
  L02_DIALOGUE,
  L03_DIALOGUE,
  L04_DIALOGUE,
  L05_DIALOGUE,
  L06_DIALOGUE,
  L07_DIALOGUE,
  L08_DIALOGUE,
  L09_DIALOGUE,
  L10_DIALOGUE,
  L11_DIALOGUE,
  L12_DIALOGUE,
  L13_DIALOGUE,
  L14_DIALOGUE,
  L15_DIALOGUE,
  L16_DIALOGUE,
  L17_DIALOGUE,
  L18_DIALOGUE,
  L19_DIALOGUE,
  L20_DIALOGUE,
  L21_DIALOGUE,
  L22_DIALOGUE,
  L23_DIALOGUE,
  L24_DIALOGUE,
  L25_DIALOGUE,
  L26_DIALOGUE,
  L27_DIALOGUE,
  L28_DIALOGUE,
  L29_DIALOGUE,
  L30_DIALOGUE,
  FALSE_ENDING_DIALOGUE,
  ENDGAME_DIALOGUE,
  LA_DIALOGUE,
  LB_DIALOGUE,
  LC_DIALOGUE,
  LD_DIALOGUE,
  LE_DIALOGUE,
  LF_DIALOGUE,
  LG_DIALOGUE,
  LH_DIALOGUE,
  LI_DIALOGUE,
  LJ_DIALOGUE,
  LK_DIALOGUE,
};
